import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import SubmitButton from "../form/SubmitButton";
import Button from "../atoms/Button";
const MeasurementProtocolModalFooter = ({ onClose, onSubmitPress }) => {
    const { t } = useTranslation();
    return (_jsxs(HStack, Object.assign({ space: 2 }, { children: [_jsx(Button, Object.assign({ variant: onSubmitPress ? "outlined" : "primary", size: "md", onPress: onClose }, { children: onSubmitPress ? t("cancel") : t("close") })), onSubmitPress && (_jsx(SubmitButton, { onPress: onSubmitPress, label: t("save") }))] })));
};
export default MeasurementProtocolModalFooter;
